import { isUndefined } from './isNonNullable';
import mergeArray from './mergeArray';
const mergeObject = (a, b) => (Object.assign(Object.assign({}, a), b));
const mergeStrategies = {
    // type. avoid setting to any
    // WARNING: must be the first!
    type: (a, b) => (b.type === 'any' ? a.type : b.type),
    // object fields
    fields: (a, b) => (a.type !== 'object' ? void 0 : mergeArray(a.fields, b.fields, 'id', mergeDataSchema)),
    additionalFields: (a, b) => (a.type !== 'object' ? void 0 : mergeDataSchema(a.additionalFields, b.additionalFields)),
    // array items
    items: (a, b) => (a.type !== 'array' ? void 0 : mergeDataSchema(a.items, b.items)),
    // misc (object)
    ui: (a, b) => mergeObject(a.ui, b.ui),
    validation: (a, b) => mergeObject(a.validation, b.validation),
    methods: (a, b) => mergeArray(a.methods, b.methods, 'id'),
    // misc
    enum: (a, b) => mergeArray(a.enum, b.enum, 'value'),
    groups: (a, b) => mergeArray(a.groups, b.groups, 'id', mergeObject),
    definitions: (a, b) => mergeArray(a.definitions, b.definitions, 'id', mergeDataSchema),
    examples: (a, b) => [...a.examples, ...b.examples],
};
export default function mergeDataSchema(a, b) {
    /* istanbul ignore else */
    if (!a && !b)
        return null;
    const ans = Object.assign({}, a);
    if (b) {
        Object.keys(b).forEach((k) => {
            if (isUndefined(b[k])) {
                // nothing to merge
                return;
            }
            if (isUndefined(ans[k])) {
                // regular assigning
                ans[k] = b[k];
                return;
            }
            // use merge strategy
            const mergeFn = mergeStrategies[k] || (() => b[k]);
            ans[k] = mergeFn(ans, b, k);
        });
    }
    return ans;
}
